import React from 'react';

import ControlsForward from '@videoblocks/react-icons/ControlsForward';

interface AudioPlayerForwardButtonProps {
  iconClassName?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onClick: Function;
}

const AudioPlayerForwardButton = ({
  iconClassName,
  onClick,
}: AudioPlayerForwardButtonProps): JSX.Element => {
  return (
    <ControlsForward
      className={`fill-current ${iconClassName}`}
      onClick={onClick}
    />
  );
};

export default AudioPlayerForwardButton;
